import React from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import VouchersPage from './VouchersPage';
import { useAuth } from '../../hooks/useAuth';
import { useIsMobile } from '../../hooks/useIsMobile';

function VouchersPageWrapper() {
  const { profile } = useAuth();
  const isMobile = useIsMobile();
  const userName = profile?.name || 'Usuário';

  return (
    <div style={{ display: 'flex', height: isMobile ? '100dvh' : '100vh', flexDirection: 'column' }}>
      {!isMobile && <Header subtitle="Vouchers" userName={userName} />}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {!isMobile && <Sidebar activePage="vouchers" />}
        <VouchersPage />
      </div>
      {isMobile && <Sidebar activePage="vouchers" />}
    </div>
  );
}

export default VouchersPageWrapper;
